import React, { useState } from "react";
import Button from "../components/Button";
import Input from "../components/Input";
import firebase from "firebase";
import styled from "styled-components";
import { NavLink, useHistory } from "react-router-dom";
import logo from "../assets/logo.jpg";

const LoginWrapper = styled.div`
  display: flex;
  margin: auto;
  height: 100vh;
  justify-content: center;
  flex-direction: column;
  width: 360px;
  text-align: center;
  input {
    margin-bottom: 8px;
  }
  button {
    margin-top: 16px;
  }
`;

const Login = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [usernameOrEmail, setUsernameOrEmail] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState("");

  const onLoginAttempt = async () => {
    setError("");
    setIsLoading(true);
    const credentials = { email: usernameOrEmail, password };

    firebase
      .auth()
      .signInWithEmailAndPassword(credentials.email, credentials.password)
      .then(() => {
        setIsLoading(false);
        history.push("/");
      })
      .catch((e) => {
        setIsLoading(false);
        switch (e.code) {
          case "auth/user-not-found":
            setError("This user does not exist");
            break;
          case "auth/wrong-password":
            setError("Incorrect password");
            break;
          default:
            setError("Failed to log in");
            break;
        }
      });
  };

  return (
    <LoginWrapper>
      <img
        src={logo}
        alt="Young Coderz Logo"
        style={{ width: 96, margin: "8px auto" }}
      />
      <h2>Welcome to YoungCoderz Academy</h2>
      <Input
        value={usernameOrEmail}
        onChange={(e) => setUsernameOrEmail(e.currentTarget.value)}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            onLoginAttempt();
          }
        }}
        placeholder="Email"
        type="email"
      />
      <Input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.currentTarget.value)}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            onLoginAttempt();
          }
        }}
        placeholder="Password"
      />
      <Button onClick={onLoginAttempt} disabled={isLoading}>
        {isLoading ? "Logging in..." : "Login"}
      </Button>
      {error && error}
      <NavLink to="/register" style={{ marginTop: 16 }}>
        First time? Register here
      </NavLink>

      <NavLink to="/forgot-password" style={{ marginTop: 16 }}>
        Forgotten your password?
      </NavLink>
    </LoginWrapper>
  );
};

export default Login;

// Styling for all pages
// Progress bar
// Leaderboard
// Session page
// Activity page

// fast styling for admin dashboard pages

// Creating parents/students
// Create class of students
// Create sessions for class
// Create activities for class / student

// View assignment
// Give or set points
